import styled from '@emotion/styled';
export const MarkerDetailLink = styled('div')(() => ({
  position: 'absolute',
  right: '15px',
  top: '15px',
  a: {
    color: 'white',
    fontFamily: 'Montserrat',
    fontSize: '15px',
    textDecoration: 'none',
  },
  'a:hover': {
    textDecoration: 'underline',
  },
}));
